import BigNumber from "bignumber.js";

export function parseAmount(amount: string | number, decimal = 18) {
  if (!amount) return "0";

  amount = cleanupAmount(String(amount));

  const split = amount.split(".");
  const wholePart = split[0];
  const fracPart = split[1] || "";
  if (split.length > 2 || fracPart.length > decimal) {
    throw new Error(`Cannot parse '${amount}' as bignumber`);
  }
  return trimLeadingZeroes(wholePart + fracPart.padEnd(decimal, "0"));
}
export function formatAmount(
  amount: string | number | undefined,
  decimal = 18
) {
  if (!amount) return "0";

  const amountBN = new BigNumber(String(amount), 10);
  amount = amountBN.toString(10);
  const wholeStr = amount.substring(0, amount.length - decimal) || "0";
  const fractionStr = amount
    .substring(amount.length - decimal)
    .padStart(decimal, "0")
    .substring(0, decimal);

  return trimTrailingZeroes(`${wholeStr}.${fractionStr}`);
}

// 添加千分位格式化辅助函数
function addThousandsSeparator(num: string): string {
  const parts = num.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatAmountWithFixed(
  amount: string | number | undefined,
  decimal = 18,
  pp = 2
) {
  const amountStr = formatAmount(amount, decimal);
  let result;

  if (accGte(amountStr, "1")) {
    result = toFixed(amountStr, pp);
  } else {
    result = formatSignificantDigits(amountStr, pp);
  }

  return addThousandsSeparator(result);
}

export function cleanupAmount(amount: string) {
  return amount.replace(/,/g, "").trim();
}

export function trimTrailingZeroes(value: string) {
  return value.replace(/\.?0*$/, "");
}

export function trimLeadingZeroes(value: string) {
  value = value.replace(/^0+/, "");
  if (value === "") {
    return "0";
  }
  return value;
}

export function toFixed(number: string, pp: number) {
  const p = isNaN(pp) || !pp ? 0 : pp;
  let num = getFullNum(number);
  const n = (num + "").split(".");
  let x = n.length > 1 ? n[1] : "";
  if (x.length > p) {
    x = x.substr(0, p);
  } else {
    x += Array(p - x.length + 1).join("0");
  }
  return parseFloat(n[0] + (x == "" ? "" : "." + x)).toString();
}
export function accMul(arg1: string | number, arg2: string | number) {
  if (!arg1 || !arg2) {
    return "0";
  }
  const num = new BigNumber(arg1).times(new BigNumber(arg2));
  return num.toString();
}

export function getFullNum(num: string) {
  const str = String(num);
  if (!/e/i.test(str)) {
    return num;
  }
  return Number(num)
    .toFixed(18)
    .replace(/\.?0+$/, "");
}

export function accDiv(
  arg1: string | number | undefined,
  arg2: string | number | undefined
) {
  if (!arg1 || !arg2) {
    return "0";
  }
  const num = new BigNumber(arg1).div(new BigNumber(arg2));
  return num.toFixed();
}

export function accAdd(
  arg1: string | number | undefined,
  arg2: string | number | undefined
) {
  if (!arg1 || !arg2) {
    return "0";
  }
  const num = new BigNumber(arg1).plus(new BigNumber(arg2));
  return num.toFixed();
}
export function accSub(
  arg1: string | number | undefined,
  arg2: string | number | undefined
) {
  if (!arg1 || !arg2) {
    return "0";
  }
  const num = new BigNumber(arg1).minus(new BigNumber(arg2));
  return num.toFixed();
}

// 大于等于
export function accGte(arg1: string | number, arg2: string | number) {
  return new BigNumber(arg1).gte(new BigNumber(arg2));
}

// 大于
export function accGt(arg1: string | number, arg2: string | number) {
  return new BigNumber(arg1).gt(new BigNumber(arg2));
}

export function formatAndToSignificantDigits(
  num: string | number | undefined,
  decimals: number | undefined,
  significantDigits: number = 6
): string {
  if (!num || !decimals) return "0";

  return formatSignificantDigits(
    formatAmount(num, decimals),
    significantDigits
  );
}

// 处理有效位数
export function formatSignificantDigits(
  num: string | number,
  significantDigits: number = 6
): string {
  if (!num) return "0";

  const bn = new BigNumber(num);
  // 使用 precision 方法设置有效位数
  const formatted = bn
    .precision(significantDigits, BigNumber.ROUND_DOWN)
    .toString();

  return formatted;
}
